import { Card, Descriptions, Empty, Typography } from 'antd'
import dayjs from 'dayjs'
import type { ITeacherDemoNetworkCheck } from '~/types/teacher-application'

const statusLabels: Record<string, string> = {
  COMPLETE: '检测完成', TIMEOUT: '检测超时', UNAVAILABLE: '未获得有效测量',
  PENDING: '检测未完成', DISABLED: '检测未启用',
}
const qualityLabels = ['未知', '优秀', '良好', '较差', '差', '非常差', '连接中断']
const measurement = (value: number | null | undefined, unit: string, scale = 1) =>
  typeof value === 'number' && Number.isFinite(value) && value >= 0 ? `${(value * scale).toFixed(1)} ${unit}` : '—'

export function DemoNetworkCheckCard({ check }: { check?: ITeacherDemoNetworkCheck | null }) {
  return <Card title="Demo 课前网络检测" size="small">
    {!check ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="该 Demo 未采集课前网络检测数据" /> : <>
      <Descriptions bordered size="small" column={2}>
        <Descriptions.Item label="检测状态">{statusLabels[check.status] ?? '未知'}</Descriptions.Item>
        <Descriptions.Item label="检测时间">{dayjs(check.requestedAt).format('YYYY-MM-DD HH:mm:ss')}</Descriptions.Item>
        {check.status === 'COMPLETE' && <>
          <Descriptions.Item label="网络质量">{qualityLabels[check.networkQuality ?? 0] ?? '未知'}</Descriptions.Item>
          <Descriptions.Item label="往返延迟（RTT）">{measurement(check.rttMs, 'ms')}</Descriptions.Item>
          <Descriptions.Item label="抖动">{measurement(check.jitterMs, 'ms')}</Descriptions.Item>
          <Descriptions.Item label="丢包率">{measurement(check.packetLossRatio, '%', 100)}</Descriptions.Item>
        </>}
        <Descriptions.Item label="检测耗时">{measurement(check.durationMs, '秒', 0.001)}</Descriptions.Item>
      </Descriptions>
      <Typography.Paragraph type="secondary" style={{ marginTop: 12, marginBottom: 0 }}>
        老师浏览器在 Demo 开始前自动测量，随本次 Demo 保存。结果反映当时到声网服务的连接情况，不代表整节课或与特定学生之间的延迟。超时或未获得测量不等于网络差，供人工审核参考。
      </Typography.Paragraph>
    </>}
  </Card>
}
